import React from "react";
import { Tab, Header, Segment } from "semantic-ui-react";
import ChangePasswordContainer from "../containers/ChangePasswordContainer";
import EditUserContainer from "../containers/EditUserContainer";
import { translate } from "react-i18next";
const EditUserTabComponent = props => {
  const panes = [
    {
      menuItem: props.t("user:userInfoText"),
      render: () => (
        <Tab.Pane>
          <EditUserContainer {...props} />
        </Tab.Pane>
      )
    },
    {
      menuItem: props.t("changePassword:changePasswordText"),
      render: () => (
        <Tab.Pane>
          <Segment basic>
            <ChangePasswordContainer />
          </Segment>
        </Tab.Pane>
      )
    }
  ];
  return (
    <React.Fragment>
      <Header as="h1">{props.t("user:editUserText")}</Header>
      <Tab panes={panes} />
    </React.Fragment>
  );
};

export default translate("translations")(EditUserTabComponent);



// WEBPACK FOOTER //
// ./src/components/EditUserTabComponent.js